"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_modal_1 = __importDefault(require("react-modal"));
const common_styled_components_1 = require("../../common-styled-components");
const apiUtils_1 = require("../../../util/apiUtils");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const react_select_1 = __importDefault(require("react-select"));
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const useSendFile_1 = __importDefault(require("../../../hooks/useSendFile"));
const YearContext_1 = require("../../../contexts/YearContext");
const modalStyles = {
    ...common_styled_components_1.baseReactModalStyles,
    content: {
        ...common_styled_components_1.baseReactModalStyles.content,
        display: "flex",
    },
};
const ModalContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(3)};
`;
const Form = styled_components_1.default.form `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(3)};
`;
const getTypeOptions = (metadata) => Object.keys(metadata.report_type).map((t) => ({
    label: metadata.report_type[Number(t)],
    value: Number(t),
}));
const getPoolOptions = (pools) => pools.map((pool) => ({
    label: pool.name,
    value: pool.id,
}));
const getFleetOptions = (fleets) => fleets.map((fleet) => ({
    label: fleet.name,
    value: fleet.id,
}));
const ReportUploader = ({ title, initialBody, metadata, }) => {
    const typeOptions = getTypeOptions(metadata);
    const [file, setFile] = (0, react_1.useState)(null);
    const [selectedType, setSelectedType] = (0, react_1.useState)(Number(typeOptions?.[0]?.value) ?? null);
    const [selectedPool, setSelectedPool] = (0, react_1.useState)(initialBody?.pool_id ?? null);
    const [selectedFleet, setSelectedFleet] = (0, react_1.useState)(initialBody?.fleet_id ?? null);
    const [isOpen, setOpen] = (0, react_1.useState)(false);
    const [overview, _setOverviewUrl, setOverviewBody] = (0, useFetch_1.default)("admin/overview.json", undefined, true);
    const { selectedYear } = (0, YearContext_1.useYear)();
    (0, react_1.useEffect)(() => {
        setOverviewBody(JSON.stringify({ pool_year: selectedYear }));
    }, [selectedYear, setOverviewBody]);
    const [sendFile, fileSendMessage] = (0, useSendFile_1.default)("admin/add_report");
    const handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            setFile(event.target.files[0]);
        }
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!file) {
            return;
        }
        if (typeOptions && !selectedType) {
            return;
        }
        console.info("Sending", file.name, ", report type", typeOptions?.find((t) => t.value === selectedType)?.label, ", other options", selectedFleet, selectedPool);
        const formData = new FormData();
        // Append the file using the provided fileKey
        formData.append("report", file);
        if (typeOptions && selectedType !== null) {
            formData.append("report_type", selectedType.toString());
        }
        if (selectedFleet !== null) {
            formData.append("fleet_id", selectedFleet.toString());
        }
        if (selectedPool !== null) {
            formData.append("pool_id", selectedPool.toString());
        }
        sendFile(formData);
    };
    const fleetOptions = overview.status === apiUtils_1.LoaderStatus.Success
        ? getFleetOptions(overview.data.fleets)
        : undefined;
    const poolOptions = overview.status === apiUtils_1.LoaderStatus.Success
        ? getPoolOptions(overview.data.pools)
        : undefined;
    const disabled = selectedFleet === null || selectedPool === null || file === null;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: isOpen, onRequestClose: () => setOpen(false), contentLabel: title, style: modalStyles, shouldCloseOnEsc: true, children: (0, jsx_runtime_1.jsxs)(ModalContent, { children: [(0, jsx_runtime_1.jsx)("h2", { children: title }), poolOptions && fleetOptions && ((0, jsx_runtime_1.jsxs)(Form, { onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)("input", { type: "file", onChange: handleFileChange }), typeOptions && ((0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Report type" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: typeOptions, onChange: (newValue) => setSelectedType(newValue?.value ?? null), isOptionSelected: (o) => o?.value === selectedType, value: typeOptions.find((o) => o?.value === selectedType) ??
                                                undefined })] })), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Fleet" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: fleetOptions, onChange: (newValue) => setSelectedFleet(newValue?.value ?? null), isOptionSelected: (o) => o?.value === selectedFleet, value: fleetOptions.find((o) => o?.value === selectedFleet) ??
                                                undefined })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Pool" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: poolOptions, onChange: (newValue) => setSelectedPool(newValue?.value ?? null), isOptionSelected: (o) => o?.value === selectedPool, value: poolOptions.find((o) => o?.value === selectedPool) ??
                                                undefined })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { type: "submit", disabled: disabled, children: disabled ? "Select pool, fleet, and file" : "Upload" })] })), fileSendMessage && (0, jsx_runtime_1.jsx)("p", { children: fileSendMessage }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: () => setOpen(false), children: "Close" })] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: () => setOpen(true), children: title })] }));
};
exports.default = ReportUploader;
